import { atom } from 'jotai';
import type { AnalysisMode } from '@/types';

export const currentJobIdAtom = atom<string | null>(null);

export const analysisModeAtom = atom<AnalysisMode>('adaptive');

export const escalateIfPromisingAtom = atom<boolean>(true);
